import { render } from "./MyCanvas.vue?vue&type=template&id=49a4916a&scoped=true"
import script from "./MyCanvas.vue?vue&type=script&lang=js"
export * from "./MyCanvas.vue?vue&type=script&lang=js"

import "./MyCanvas.vue?vue&type=style&index=0&id=49a4916a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a4916a"]])

export default __exports__